import { defineStore } from 'pinia'
import router, { asyncRoutes, constantRoutes } from '@/router'
import { CurrentMenu } from "@/api/system/menu";

// useStore 可以是 useUser、useCart 之类的任何东西
// 第一个参数是应用程序中 store 的唯一 id
export const usePermissionStore = defineStore('menu', {
  state: () => ({
    menu: [],
    btnList: [],
    permMenuList: [],
    isLoading: false, 
  }),
  actions: {
    async setPermissionInfo() {
      //console.log('setPermissionInfo')
      if (this.menu.length) {
        return Promise.resolve(this.menu)
      }
      try {
        console.log("setPermissionInfo")
        let res = await CurrentMenu();
        this.btnList = res.button_list.map(item => item.m_desc)
        //获取菜单名称和url
        let menu_list = filterMenuInfo(res.menu_list)
        //获取菜单url
        this.permMenuList = menu_list.map(item => item.url)
        let asyncRoute = filterAsyncRoutes(asyncRoutes, this.permMenuList, menu_list);
        //这里找到了home路由
        let homeRoute = constantRoutes.filter(item => item.path === '/')[0].children;
        router.addRoute(homeRoute);
        this.menu = homeRoute.concat(asyncRoute)
        return Promise.resolve(this.menu)
      } catch (error) {
        console.log("err", error);
      }
    },
  },
  getters: {
    getterMenuListInfo () {
      return this.menu;
    },
    getterBtnListInfo () {
      return this.btnList;
    },
    getterPermMenuListInfo () {
      return this.permMenuList;
    },
  }
})

function filterMenuInfo (list) {
  let arr = []
  for(let item of list) {
    let params = {
      url: item.wm_url,
      title: item.wm_name
    }
    arr.push(params) 
    if (item.children) {
      arr = arr.concat(filterMenuInfo(item.children))
    }
  }
  return arr
}

export function filterAsyncRoutes(routes, roles, menu_list) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(tmp, roles)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles, menu_list);
      }
      let data = menu_list.find(item => tmp.path === item.url)
      tmp.meta.title = data ? data.title : tmp.meta.title;
      res.push(tmp)
      router.addRoute(tmp);
    }
  })
  return res
}

export function hasPermission(route, roles) {
  
  //判断是否有权限, 如果有的话就返回true 现在没有写登录, 所以直接返回true
  if (route.meta && route.meta.requireAuth) {
    return roles.includes(route.path)
  } 
  return true
}